// Central data source for the Imaginary Collection landing page.
// Kept isolated so product pages / cart can reuse it when the site
// evolves into an e-commerce experience.

const ART = "https://customer-assets-jt897jd0.emergentagent.net/job_the-x-goes-here/artifacts/";

export const MEDIA = {
  // Hero — Murakami living room with teal X (client-provided header).
  heroStaircase: ART + "m6mdxp57_ChatGPT%20Image%20Aug%2028%2C%202026%2C%2005_04_48%20PM.png",
  // A salon-hang gallery wall of framed "X goes here" posters — a collection of dreams.
  conceptWall: ART + "k3iq74tz_ChatGPT%20Image%20Aug%206%2C%202026%2C%2007_35_00%20PM.png",
  // Monumental blue X in a skylit museum gallery — "The Monet Goes Here".
  institution: ART + "biw3fp3q_ChatGPT%20Image%20Aug%206%2C%202026%2C%2007_40_07%20PM.png",
  // The concept on an everyday object — breakfast tray.
  breakfast:
    "https://static.prod-images.emergentagent.com/jobs/0e811c03-4ca3-468f-b8e6-122181414b6d/images/5ab0e3f4662d8de44414eb77419e308e721a84f64851d9b36a19679a3de84199.jpeg",
  // "A Language Beyond Art" — opening architectural feature (three X's hallway).
  beyondFeature: ART + "1ev9sphb_ChatGPT%20Image%20Aug%206%2C%202026%2C%2005_42_18%20PM.png",
  // Sculpture pedestal — "The Koons Goes Here" dark office.
  koons: ART + "tftux56i_ChatGPT%20Image%20Aug%206%2C%202026%2C%2007_09_02%20PM.png",
};

export const DECLINAISONS = [
  {
    id: "picasso",
    phrase: "The Picasso Goes Here!",
    support: "Entryway · mural commission",
    image: ART + "sw7qmdzn_ChatGPT%20Image%20Aug%206%2C%202026%2C%2012_26_25%20PM.png",
  },
  {
    id: "vangogh",
    phrase: "The Van Gogh Goes Here.",
    support: "Living room · mural commission",
    image: ART + "rbspafd2_ChatGPT%20Image%20Aug%206%2C%202026%2C%2001_16_14%20PM.png",
  },
  {
    id: "haring",
    phrase: "The Haring Goes Here.",
    support: "Loft · mural commission",
    image: ART + "6xka79oc_ChatGPT%20Image%20Aug%206%2C%202026%2C%2005_38_27%20PM.png",
  },
  {
    id: "kusama",
    phrase: "The Kusama Goes Here.",
    support: "Hallway · mural commission",
    image: ART + "yu8t2at8_ChatGPT%20Image%20Aug%206%2C%202026%2C%2004_43_42%20PM.png",
  },
];

export const FORMATS = [
  "Custom wall painting",
  "Stickers",
  "Magnets",
  "Notebooks",
  "Trays",
  "Limited editions",
];

export const STEPS = [
  {
    n: "01",
    title: "Choose the artist or object",
    text: "You pick the name that will go beneath the X.",
  },
  {
    n: "02",
    title: "Study the space",
    text: "Measurements taken and the ideal spot located.",
  },
  {
    n: "03",
    title: "Hand-painting",
    text: "The X and the inscription, in the chosen artist's palette.",
  },
  {
    n: "04",
    title: "A one-off piece",
    text: "An original work, rooted in your interior.",
  },
];

export const PALETTES = [
  { artist: "Basquiat", colors: "Black, red, yellow", motif: "crown, skull", swatches: ["#111111", "#c8331f", "#e3b23c"] },
  { artist: "Kusama", colors: "Red, yellow, black", motif: "dots, repetition", swatches: ["#c8331f", "#e3b23c", "#111111"] },
  { artist: "Haring", colors: "Red, green, blue", motif: "thick line", swatches: ["#c8331f", "#2e8b57", "#2b5fd0"] },
  { artist: "KAWS", colors: "Grey, pink, pastels", motif: "crossed-out eyes", swatches: ["#8a8a8a", "#e7a6b8", "#cfd8dc"] },
  { artist: "Murakami", colors: "Flashy multicolour", motif: "flowers, eyes", swatches: ["#ff5ea8", "#ffd23f", "#3ac0ff"] },
];

// "A Language Beyond Art" — the concept applied to everyday objects.
// Each tile is a placeholder for desire. Optional `image` renders a photo tile.
export const BEYOND = [
  { label: "Art", subject: "The Picasso", verb: "goes here." },
  { label: "Garage", subject: "The Porsche", verb: "goes here.", image: ART + "x4j2tdef_ChatGPT%20Image%20Aug%206%2C%202026%2C%2010_03_00%20PM.png" },
  { label: "Piggy Bank", subject: "My coins", verb: "go here.", image: ART + "gdho2tyg_ChatGPT%20Image%20Aug%206%2C%202026%2C%2010_14_54%20PM.png" },
  { label: "Parking Space", subject: "The Ferrari", verb: "goes here." },
  { label: "Office", subject: "The next big idea", verb: "goes here." },
  { label: "Post-it", subject: "Your note", verb: "goes here." },
  { label: "Desk Pad", subject: "Your project", verb: "goes here." },
  { label: "Tray", subject: "The croissants", verb: "go here." },
  { label: "Entry Mat", subject: "My shoes", verb: "go here.", image: ART + "0k3rybzh_ChatGPT%20Image%20Aug%206%2C%202026%2C%2010_23_06%20PM.png" },
  { label: "Laundry Basket", subject: "The dirty clothes", verb: "go here." },
  { label: "Toilet Lid", subject: "My shit", verb: "goes here.", image: ART + "k811j11v_ChatGPT%20Image%20Aug%206%2C%202026%2C%2010_12_25%20PM.png" },
  { label: "Coffee Table", subject: "The books", verb: "go here." },
  { label: "Pet Bowl", subject: "My food", verb: "goes here." },
  { label: "Luggage Tag", subject: "My passport", verb: "goes here." },
  { label: "Wall Sticker", subject: "The Monet", verb: "goes here." },
  {
    label: "Sculpture Pedestal",
    subject: "The Koons",
    verb: "goes here.",
    image: ART + "tftux56i_ChatGPT%20Image%20Aug%206%2C%202026%2C%2007_09_02%20PM.png",
  },
];
